module.exports = __webpack_public_path__ + "media/images/flags/vi-422e0adbff13b7c0616db205b2f025fd.svg";